// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__2a5U5","avatar":"style_avatar__eSYzh"};